import { generateUtilityClasses } from '@mui/material';

export const copyButtonClasses = generateUtilityClasses('CopyButton', ['root', 'tooltip']);
